import type { SerializableHead } from '@unhead/vue'

interface Seo {
  title?: string
  description?: string
  keywords?: string
}

const normalizeCanonicalPath = (fullPath: string): string => {
  const path = fullPath.split(/[?#]/)[0] || '/'
  const normalizedPath = path.replace(/\/{2,}/g, '/')
  let pathWithLeadingSlash = normalizedPath

  if (!normalizedPath.startsWith('/')) {
    pathWithLeadingSlash = `/${normalizedPath}`
  }

  if (pathWithLeadingSlash === '/' || pathWithLeadingSlash.endsWith('/')) {
    return pathWithLeadingSlash
  }

  return `${pathWithLeadingSlash}/`
}

export const SEOMaker = (
  domain: string,
  seo: Seo | null,
  fullPath: string,
): SerializableHead => {
  const canonicalPath = normalizeCanonicalPath(fullPath)
  const canonicalUrl = `https://${domain}${canonicalPath}`

  const meta: NonNullable<SerializableHead['meta']> = [
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: canonicalUrl,
    },
    {
      property: 'og:image',
      content: `https://${domain}/farfor-og-image.png`,
    },
  ]

  if (seo?.title) {
    meta.push({
      property: 'og:title',
      content: seo.title,
    })
  }

  if (seo?.description) {
    meta.push(
      {
        property: 'og:description',
        content: seo.description,
      },
      {
        name: 'description',
        content: seo.description,
      },
    )
  }

  if (seo?.keywords) {
    meta.push({
      name: 'keywords',
      content: seo.keywords,
    })
  }

  return {
    title: seo?.title,
    link: [{ rel: 'canonical', href: canonicalUrl }],
    meta,
  }
}
